<template>
  <CardSlider :breakpoints="breakpoints" :heading="heading" class="my-20">
    <EducationTile
      v-for="tile in tiles"
      :key="tile.id"
      class="relative h-full mb-10"
      :entry="tile"
      :is-in-slider="true"
      data-test-id="tile"
    />
  </CardSlider>
</template>

<script>
import EducationTile from '@/components/education/EducationTile';
import CardSlider from '@/components/common/CardSlider';

export default defineNuxtComponent({
  components: { CardSlider, EducationTile },
  props: {
    heading: {
      type: String,
      default: null,
    },
    tiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 640,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 768,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      ],
    };
  },
});
</script>
